"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recertPayloadToFormDataHandler = recertPayloadToFormDataHandler;
function recertPayloadToFormDataHandler(data) {
    return {
        pastAppointment: {
            visitDate: data.form.visitDate,
            visitStartTime: data.form.visitTimeIn,
            visitEndTime: data.form.visitTimeOut,
        },
        physicianName: data.form.physicianName || "N/A",
        contactPersonAtDoctorOffice: data.form.contactPersonAtDoctorOffice || "N/A",
        recertFrequency: data.form.recertFrequency,
        aideRequired: data.form.aideRequired || false,
        frequencyForAide: data.form.frequencyForAide || "N/A",
    };
}
